import { RightArrow } from 'assets/icons';
import { FAQContainer, FAQElement } from 'components/shared/FAQ';
import { Container } from '..';
import { H2 } from './styleConstants';
import CustomLink from 'components/shared/CustomLink';
import styles from './FAQSection.module.css';

type FAQ = {
  title: string;
  description: React.ReactNode;
};
export const faqData: FAQ[] = [
  {
    title: 'What is Blood Vision?',
    description: (
      <>
        Our newest product, Blood Vision - powered by UltraTrace™ technology
        allows seamless correlation to the changes in your sleep, resting HR,
        HRV, and movement trends with pertinent markers in the blood. Decades of
        meticulous research underpin this categorisation.
        <br />
        <br />
        For instance, UltraTrace™ can ascertain how a specific improvement in
        sleep quality might influence a marker like LDL, providing users with a
        probability score. This intuitive understanding empowers individuals to
        grasp the intricate connections between lifestyle habits and their
        direct impact on blood markers.
      </>
    ),
  },
  {
    title: 'What you need to know about booking a Blood Vision Test',
    description: (
      <>
        You can book your Blood Vision Test via the Ultrahuman app. You can also
        book a test for your friends and family here. All available test
        packages are visible in the app&apos;s vision tab. You can select a slot
        for the appointment and enter patient details accordingly.
        <br />
        <br />
        <br />
        All sample collections are carried out from the comfort of your home. To
        ensure a seamless experience, our collection partners arrive on time at
        your address and this can be tracked via the app in real-time as well.
        <br />
        <br />
        Post-collection, partial reports will start to show the same day. Final
        reports will show in the app and be shared over email once ready!
      </>
    ),
  },
  {
    title: 'Is my location serviceable?',
    description: (
      <>
        We are live in 2000+ pincodes spread across 60+ cities.
        <br />
        <br />
        To check if we serve your pin code, head over to the Ultrahuman app &gt;
        Vision tab &gt; Book Now &gt; Add your address here to check!
      </>
    ),
  },
  {
    title: 'What are the different tests available?',
    description: (
      <>
        We have 14 tests available as of now.
        <br />
        <br />
        They are Peak Performance, Foundational, Advanced, Hormone Health,
        Diabetes Risk, Heart Health, Inflammation Status, Recovery Panel,
        Fatigue, Sleep Status, Menstrual Health (female only)
      </>
    ),
  },
];

export const FAQSection = ({
  className,
  faqData,
}: {
  className?: string;
  faqData: {
    title: string;
    description: React.ReactNode;
  }[];
}) => {
  return (
    <section className={className ? `${styles.root} ${className}` : styles.root}>
      <Container>
        <H2>Frequently asked questions</H2>
        <FAQContainer>
          {faqData.map((faq, i) => {
            return <FAQElement key={i} {...faq} />;
          })}
        </FAQContainer>
        <div className="" style={{ textAlign: 'center' }}>
          <CustomLink href="/blood-vision/faq">
            See all FAQs <RightArrow fill="#000000" />
          </CustomLink>
        </div>
      </Container>
    </section>
  );
};
